(() => {
  if (window.__avryloProductUxLoaded) return;
  window.__avryloProductUxLoaded = true;

  const LIMIT = 6;
  let scheduled = false;

  function enhanceLongVariantGroups(root = document) {
    const groups = root.querySelectorAll?.(
      '[data-testid="product-information"] .variant-option--buttons:not(.variant-option--swatches)'
    );
    if (!groups) return;

    groups.forEach((fieldset) => {
      const labels = Array.from(
        fieldset.querySelectorAll(':scope > .variant-option__button-label')
      );

      if (labels.length <= LIMIT) {
        fieldset.classList.remove('avrylo-variant-collapsible', 'avrylo-variant-expanded');
        fieldset.querySelector(':scope > .avrylo-variant-more')?.remove();
        return;
      }

      fieldset.classList.add('avrylo-variant-collapsible');

      if (!fieldset.querySelector(':scope > .avrylo-variant-more')) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'avrylo-variant-more';
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Vezi mai multe opțiuni';
        fieldset.appendChild(button);
      }
    });
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhanceLongVariantGroups(document);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.avrylo-variant-more');
    if (!button) return;

    const fieldset = button.closest('.avrylo-variant-collapsible');
    if (!fieldset) return;

    const expanded = !fieldset.classList.contains('avrylo-variant-expanded');
    fieldset.classList.toggle('avrylo-variant-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Arată mai puține' : 'Vezi mai multe opțiuni';
  });

  function start() {
    enhanceLongVariantGroups(document);

    const observer = new MutationObserver(scheduleEnhance);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
